<app-toasts aria-live="polite" aria-atomic="true"></app-toasts>
<router-outlet ngxUiLoaderBlurred [blur]="10"></router-outlet>
<ngx-ui-loader></ngx-ui-loader>
